/* eslint-disable import/prefer-default-export */
import { FETCH_LOGS } from './types';

const fetchLogAction = (payload) => ({
  type: FETCH_LOGS,
  payload,
});

export { fetchLogAction };
